import React from 'react';
import { getUserData } from "../../services/API";
import { COPY_STRINGS } from '../../constants/translatedCopy';

import { BADGE_IMAGE, REWARD_LEVEL, DANCE_TITLES } from '../../services/badging/constants';
import { sortBadgesByLevelDesc } from '../../components/Badging/utils';
import { DANCES } from "../../components/Coach/Coach";
import { updateBadge } from '../../services/badging/updateBadge/updateBadge';
import { getRandomArrayElement } from '../../library';

function BadgeAwardDisplay(props) {
  const { rewardLevelId } = props;
  return (
    <div className="badge-award-display">
      <img className="badge-award-image" src={BADGE_IMAGE[rewardLevelId]} alt={`${rewardLevelId} badge`} />
    </div>
  );
}

function sortAndFilterBadges(badges) {
  const filteredBadges = badges.filter((badge) => !badge.seen && badge.awarded);
  const sortedBadges = sortBadgesByLevelDesc(filteredBadges);
  const mappedBadges = {};
  sortedBadges.forEach((x) => {
    if (!mappedBadges[x.badgeTypeId]) mappedBadges[x.badgeTypeId] = x;
  });
  return Object.keys(mappedBadges).map((key) => mappedBadges[key]);
}

function markAllBadgesSeen() {
  const { badges } = getUserData();
  const filteredBadges = badges.filter((badge) => !badge.seen && badge.awarded);
  const updateBadgeCalls = filteredBadges.map((badge) => {
    badge.seen = true;
    return updateBadge({ studentId: getUserData().userId, badgeId: badge.id, seen: true });
  });
  return Promise.all(updateBadgeCalls);
}

function findDance(title) {
  return DANCES.find((dance) => dance.title === title);
}

function getBadgeDance(badge) {
  let dance;
  if ([REWARD_LEVEL.PAL, REWARD_LEVEL.BUDDY].includes(badge.rewardLevelId)) dance = findDance(DANCE_TITLES.CHICKEN);
  if ([REWARD_LEVEL.RANGER, REWARD_LEVEL.TITAN].includes(badge.rewardLevelId)) dance = findDance(DANCE_TITLES.RENEGADE);
  if ([REWARD_LEVEL.GURU, REWARD_LEVEL.WIZARD].includes(badge.rewardLevelId)) dance = findDance(DANCE_TITLES.FLOSS);
  return dance;
}

export async function openBadgeNotifications({ userId, openModal, speech }) {
  return new Promise(async (resolve, reject) => {
    const {badges: allBadges, isEarlyReader} = getUserData();
    const filteredSortedBadges = sortAndFilterBadges(allBadges);
    if (filteredSortedBadges.length === 0) return resolve();
    await speech.speakWithPromise({ textToSpeak: getRandomArrayElement(COPY_STRINGS.you_earned_badges) });

    let index = 0;
    for (const badge of filteredSortedBadges) {
      const badgeName = badge.rewardLevelId;
      const description = badge.description;

      openModal(<BadgeAwardDisplay rewardLevelId={badge.rewardLevelId} />, { backgroundClose: false, key: 'studentHome' });
      await speech.speakWithPromise({ textToSpeak: COPY_STRINGS.im_awarding_you({ badgeName }) });
      await speech.speakWithPromise({ textToSpeak: description });
      badge.seen = true;
      await updateBadge({ studentId: userId, badgeId: badge.id, seen: true });
      if (index < filteredSortedBadges.length - 1) await speech.speakWithPromise({ textToSpeak: COPY_STRINGS.and });
      index += 1;
    }
    markAllBadgesSeen();
    if (!isEarlyReader) {
      await speech.speakWithPromise({ textToSpeak: COPY_STRINGS.to_see_your_badges });
    } else {
      await speech.speakWithPromise({ textToSpeak: COPY_STRINGS.to_see_your_badges_early_reader });
    }

    speech.playDance(getBadgeDance(filteredSortedBadges[0]), resolve);
  });
}
